import React from 'react';
import PropTypes from 'prop-types';
import {ButtonWithIcon} from '@/components/atoms';
import {SIZE} from '@/utils/constants/globalStyle';
import {COLOR} from '@/utils/constants/colors';
import {CSS_CLASSES, BUTTON_CONFIG} from '../common/ReviewConstants';

const EditButton = ({phaseNumber, onClick}) => {
  const handleClick = (e) => {
    e?.stopPropagation();
    if (onClick) {
      onClick(phaseNumber);
    }
  };

  return (
    <ButtonWithIcon
      uiSchema={{
        className: CSS_CLASSES.BUTTONS.EDIT,
        title: BUTTON_CONFIG.EDIT.TITLE,
        size: SIZE.SMALL,
        variant: COLOR.TERTIARY,
        isDark: true
      }}
      iconLeading={BUTTON_CONFIG.EDIT.ICON}
      handleButton={handleClick}
    />
  );
};

EditButton.propTypes = {
  phaseNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onClick: PropTypes.func.isRequired
};

export default EditButton;
